var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "customAbout", staticClass: "custom-about" }),
    _vm._v(" "),
    _vm.showDefaultAboutContent
      ? _c(
          "div",
          { ref: "aboutContainer", staticClass: "about-container" },
          [
            _c("header", { staticStyle: { "margin-top": "0" } }, [
              _c("img", {
                ref: "aboutLogo",
                staticClass: "logo",
                attrs: {
                  height: "auto",
                  src: _vm.getImgSrc("logoImgSrc"),
                  width: "200px"
                }
              })
            ]),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c(
              "section",
              [
                _c(
                  "v-alert",
                  { attrs: { outline: "", value: true, color: "info" } },
                  [
                    _c("h3", { staticClass: "header" }, [
                      _vm._v(" " + _vm._s(_vm.$t("about.donate")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "textjustify" }, [
                      _vm._v(_vm._s(_vm.$t("about.donateText")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href: _vm.constants.links.osmLink,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("about.openStreetMapOrg")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "textjustify" }, [
                  _vm._v(_vm._s(_vm.$t("about.info_I")))
                ]),
                _vm._v(" "),
                _c(
                  "v-alert",
                  { attrs: { outline: "", value: true, color: "info" } },
                  [
                    _c("h3", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("about.infoSupport")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "textjustify" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: {
                            href: _vm.constants.links.donate,
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("about.supportText")))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", { staticClass: "textjustify" }, [
                  _vm._v(_vm._s(_vm.$t("about.info_II")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c("section", [
              _c("h4", { staticClass: "sectionHeader" }, [
                _vm._v(_vm._s(_vm.$t("about.softwareAndLibraries")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "textjustify" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("about.dataProvided")) + " "
                ),
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: {
                      href: _vm.constants.links.aboutGHSL,
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("about.ghsFramework")))]
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n        " + _vm._s(_vm.$t("about.sources")) + " "),
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: {
                      href: _vm.constants.links.source,
                      target: "_blank"
                    }
                  },
                  [_vm._v("github")]
                ),
                _vm._v(".\n      ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("about.feelFreeToReportBugs")) + " "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.constants.links.reportIssue,
                      target: "_blank"
                    }
                  },
                  [_vm._v("github")]
                ),
                _vm._v("\n        " + _vm._s(_vm.$t("about.orToFixThem")) + ".")
              ])
            ]),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "section",
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.constants.links.heiGitEn,
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "brand",
                      attrs: {
                        height: "auto",
                        src: _vm.getImgSrc("brandLogoSrc"),
                        width: "150px"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("about.info_IV")))]),
                _vm._v(" "),
                _c("span", [
                  _c(
                    "h3",
                    [
                      _c("v-icon", [_vm._v("help")]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.constants.links.askOrs,
                            target: "_blank"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("about.askOpenrouteservice"))
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", { staticClass: "textjustify" }, [
                  _vm._v(_vm._s(_vm.$t("about.info_V")))
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("h4", { staticClass: "sectionHeader" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        title: _vm.$t("about.privacyPolicy"),
                        href: _vm.constants.links.privacyPolicy,
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("about.privacyPolicy")))]
                  ),
                  _vm._v("   \n        "),
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        title: _vm.$t("about.termsOfService"),
                        href: _vm.constants.links.termsOfService,
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("about.termsOfService")))]
                  )
                ]),
                _vm._v(" "),
                _c("br")
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05086cf6", { render: render, staticRenderFns: staticRenderFns })
  }
}